import { IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react'
import { bulb, flash, home, tv } from 'ionicons/icons'
import React, { useContext, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import useUser from '../../contexts/hooks/useUser'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import { UserContext } from '../../contexts/UserContext'
import '../../theme/tabs.scss'
import Sidebar from '../layout/Sidebar'

const NativeAppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { t } = useTranslation('pages_mainTabs')
	const { hasObjects } = useContext(ObjectContext)
	const { skipLogin } = useContext(UserContext)

	const { user } = useUser()

	// Logic: (Always show if skipLogin) OR (Show if user exists), With this we prevent showing the navigation buttons before registration is complete
	const shouldShowNavigation = useMemo(() => {
		if (skipLogin) return true
		if (user?.email && user.email.includes('@')) return true

		return false
	}, [skipLogin, user, hasObjects])

	return (
		<>
			{shouldShowNavigation ? <Sidebar /> : null}
			<IonTabs>
				<IonRouterOutlet>{children}</IonRouterOutlet>

				<IonTabBar
					className={`main-tabs ${!shouldShowNavigation ? 'tabs-hidden' : ''}`}
					slot='bottom'
					key={skipLogin || user ? 'auth-true' : 'auth-false'}
				>
					<IonTabButton tab='overview' href='/overview'>
						<IonIcon icon={home} />
						<IonLabel>{t('koti')}</IonLabel>
					</IonTabButton>

					<IonTabButton tab='exchange' href='/exchange'>
						<IonIcon icon={flash} />
						<IonLabel>{t('sahko')}</IonLabel>
					</IonTabButton>

					<IonTabButton tab='devices' href='/devices'>
						<IonIcon icon={tv} />
						<IonLabel>{t('laitteet')}</IonLabel>
					</IonTabButton>

					<IonTabButton tab='saving' href='/saving'>
						<IonIcon icon={bulb} />
						<IonLabel>{t('saasto')}</IonLabel>
					</IonTabButton>
				</IonTabBar>
			</IonTabs>
		</>
	)
}

export default NativeAppLayout
